var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ExActionsPopUp',{attrs:{"value":_vm.show,"actionLabel":'Archive',"headline":"Archive Employee","avatar":_vm.avatar,"htmlInfo":_vm.info,"destructive":true,"centerHeadline":true,"actionsTopSpacing":"32px"},on:{"onAction":function($event){return _vm.$emit('onAction', $event)},"input":function($event){return _vm.$emit('onClose')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }